// ===== Simple Mode DOM refs =====
const simpleModeEl = document.getElementById("simpleMode") as HTMLDivElement;
const simpleConnectBtn = document.getElementById("simpleConnectBtn") as HTMLButtonElement;
const simpleIdlePanel = document.getElementById("simple-idle") as HTMLDivElement;
const simpleProgressPanel = document.getElementById("simple-progress") as HTMLDivElement;
const simpleConfirmPanel = document.getElementById("simple-confirm") as HTMLDivElement;
const simpleErrorPanel = document.getElementById("simple-error") as HTMLDivElement;
const simpleDonePanel = document.getElementById("simple-done") as HTMLDivElement;
const simpleStepsEl = document.getElementById("simple-steps") as HTMLDivElement;
const simpleProgressBar = document.getElementById("simple-progress-bar") as HTMLProgressElement;
const simpleProgressPct = document.getElementById("simple-progress-pct") as HTMLSpanElement;
const simpleProgressWrap = document.getElementById("simple-progress-wrap") as HTMLDivElement;
const simpleStatusText = document.getElementById("simple-status-text") as HTMLParagraphElement;
const simpleYesBtn = document.getElementById("simple-yes-btn") as HTMLButtonElement;
const simpleNoBtn = document.getElementById("simple-no-btn") as HTMLButtonElement;
const simpleRetryBtn = document.getElementById("simple-retry-btn") as HTMLButtonElement;
const simpleRestartBtn = document.getElementById("simple-restart-btn") as HTMLButtonElement;
const simpleDeviceType = document.getElementById("simple-device-type") as HTMLParagraphElement;
const simpleCurrentVersion = document.getElementById("simple-current-version") as HTMLSpanElement;
const simpleLatestVersion = document.getElementById("simple-latest-version") as HTMLSpanElement;
const simpleRay5Warning = document.getElementById("simple-ray5-warning") as HTMLParagraphElement;
const simpleErrorText = document.getElementById("simple-error-text") as HTMLParagraphElement;

// ===== Professional Mode DOM refs =====
const baudrates = document.getElementById("baudrates") as HTMLSelectElement;
const consoleBaudrates = document.getElementById("consoleBaudrates") as HTMLSelectElement;
const reconnectDelay = document.getElementById("reconnectDelay") as HTMLInputElement;
const maxRetriesInput = document.getElementById("maxRetries") as HTMLInputElement;
const connectButton = document.getElementById("connectButton") as HTMLButtonElement;
const traceButton = document.getElementById("copyTraceButton") as HTMLButtonElement;
const disconnectButton = document.getElementById("disconnectButton") as HTMLButtonElement;
const resetButton = document.getElementById("resetButton") as HTMLButtonElement;
const consoleStartButton = document.getElementById("consoleStartButton") as HTMLButtonElement;
const consoleStopButton = document.getElementById("consoleStopButton") as HTMLButtonElement;
const eraseButton = document.getElementById("eraseButton") as HTMLButtonElement;
const addFileButton = document.getElementById("addFile") as HTMLButtonElement;
const programButton = document.getElementById("programButton");
const filesDiv = document.getElementById("files");
const terminal = document.getElementById("terminal");
const programDiv = document.getElementById("program");
const consoleDiv = document.getElementById("console");
const lblBaudrate = document.getElementById("lblBaudrate");
const lblConsoleBaudrate = document.getElementById("lblConsoleBaudrate");
const lblConsoleFor = document.getElementById("lblConsoleFor");
const lblConnTo = document.getElementById("lblConnTo");
const table = document.getElementById("fileTable") as HTMLTableElement;
const alertDiv = document.getElementById("alertDiv");
const flashMode = document.getElementById("flashMode") as HTMLSelectElement;
const flashFreq = document.getElementById("flashFreq") as HTMLSelectElement;
const flashSize = document.getElementById("flashSize") as HTMLSelectElement;
const lblFlashMode = document.getElementById("lblFlashMode");
const lblFlashFreq = document.getElementById("lblFlashFreq");
const lblFlashSize = document.getElementById("lblFlashSize");

const debugLogging = document.getElementById("debugLogging") as HTMLInputElement;

type FileInputWithData = HTMLInputElement & { data?: Uint8Array };

// This is a frontend example of Esptool-JS using local bundle file
// To optimize use a CDN hosted version like
// https://unpkg.com/esptool-js@0.5.0/bundle.js
import {
  ESPLoader,
  FlashOptions,
  FlashModeValues,
  FlashFreqValues,
  FlashSizeValues,
  LoaderOptions,
  Transport,
} from "../../../lib";
import { serial } from "web-serial-polyfill";
import {
  fetchUrlAsUint8Array,
  fetchOtaFirmwareList,
  prefetchOtaFirmwareList,
  iiResponseLooksValid,
  matchFirmwareResource,
  parseIiBracketFields,
  resolveCanonicalMachineKey,
  isMksRay5Firmware12x,
  getFirmwareListFetchUrl,
  isLongerLaserOldB1,
  MSG_ONLINE_OTA_NOT_SUPPORTED,
  isLongerLaserRay5,
  LIMIT_SWITCH_QUERY_CMD,
  parseLimitSwitchFromD20,
} from "./firmwareIiMatch";
import { COMPANY_SERIAL_REQUEST_OPTIONS } from "./usbSerialFilters";
import "bootstrap/dist/css/bootstrap.min.css";
// 图片以 data-url 内联进 JS，避免 Parcel 在 dist 输出带 hash 的 .png（会触发本机加密软件）
import headerLogoUrl from "data-url:../assets/esp-logo.png";
import faviconUrl from "data-url:../assets/favicon-48.png";

(document.getElementById("headerLogo") as HTMLImageElement).src = headerLogoUrl;
const siteFavicon = document.createElement("link");
siteFavicon.rel = "icon";
siteFavicon.href = faviconUrl;
document.head.appendChild(siteFavicon);

const serialLib = !navigator.serial && navigator.usb ? serial : navigator.serial;

declare let Terminal; // Terminal is imported in HTML script
declare let CryptoJS; // CryptoJS is imported in HTML script

const term = new Terminal({ cols: 120, rows: 40 });
term.open(terminal);

/** OTA / 匹配诊断：同时写 xterm 与浏览器控制台（简易模式下 #terminal 在隐藏的 #main 里） */
function otaLog(line: string): void {
  term.writeln(line);
  // eslint-disable-next-line no-console
  console.log(line);
}

// 进入页面即请求 OTA 列表（连接设备时复用缓存，方便后端联调）
{
  const listUrl = getFirmwareListFetchUrl();
  otaLog(`[OTA] GET ${listUrl} (page load)`);
  void prefetchOtaFirmwareList(otaLog).then((list) => {
    otaLog(`[OTA] Prefetch ready: ${list.length} entries`);
  });
}

let device = null;
let deviceInfo = null;
let transport: Transport;
let chip: string = null;
let esploader: ESPLoader;

disconnectButton.style.display = "none";
document.getElementById("alertDismissBtn")?.addEventListener("click", (e) => {
  e.preventDefault();
  alertDiv.style.display = "none";
});
traceButton.style.display = "none";
eraseButton.style.display = "none";
consoleStopButton.style.display = "none";
resetButton.style.display = "none";
filesDiv.style.display = "none";
flashMode.style.display = "none";
flashFreq.style.display = "none";
flashSize.style.display = "none";
lblFlashMode.style.display = "none";
lblFlashFreq.style.display = "none";
lblFlashSize.style.display = "none";

/**
 * The built in Event object.
 * @external Event
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Event}
 */

/**
 * File reader handler to read given local file.
 * @param {Event} evt File Select event
 */
function handleFileSelect(evt) {
  const file = evt.target.files[0];

  if (!file) return;

  const reader = new FileReader();

  reader.onload = (ev: ProgressEvent<FileReader>) => {
    if (ev.target.result instanceof ArrayBuffer) {
      evt.target.data = new Uint8Array(ev.target.result);
    } else {
      evt.target.data = ev.target.result;
    }
  };

  reader.readAsArrayBuffer(file);
}

const espLoaderTerminal = {
  clean() {
    term.clear();
  },
  writeLine(data) {
    term.writeln(data);
  },
  write(data) {
    term.write(data);
  },
};

/** Plain-text command to request firmware info after loader connect (e.g. Klipper-style). */
const FIRMWARE_INFO_CMD = "$i";
const FIRMWARE_INFO_TIMEOUT_MS = 2500;

/** Company-only application UART speeds; the other rate is tried if $i gets no bytes. */
const COMPANY_APP_BAUD_ALT: Record<115200 | 921600, 115200 | 921600> = {
  115200: 921600,
  921600: 115200,
};

/** Raw write without SLIP; uses {@link Transport.device} so it works even if Parcel serves an older bundled Transport (no rawWrite). */
async function transportRawWrite(t: Transport, data: Uint8Array) {
  const writable = t.device.writable;
  if (!writable) return;
  const writer = writable.getWriter();
  try {
    await writer.write(data);
  } finally {
    writer.releaseLock();
  }
}

/**
 * Send a raw serial line (no SLIP) and print the reply in the xterm. Incoming data is taken from
 * {@link Transport}'s buffer, which the background read loop keeps filling.
 */
async function sendConsoleCommandAndShowResponse(
  cmdLine: string,
): Promise<{ ok: boolean; rawText: string }> {
  const enc = new TextEncoder();
  const dec = new TextDecoder();
  transport.flushInput();
  const payload =
    cmdLine.endsWith("\r") || cmdLine.endsWith("\n") ? cmdLine : `${cmdLine}\r\n`;
  term.writeln(`> ${payload.replace(/\r?\n$/, "")}`);
  await transportRawWrite(transport, enc.encode(payload));

  const start = Date.now();
  let lastLen = 0;
  let lastChange = Date.now();

  while (Date.now() - start < FIRMWARE_INFO_TIMEOUT_MS) {
    const buf = transport.peek();
    const text = dec.decode(buf);

    if (buf.length !== lastLen) {
      lastLen = buf.length;
      lastChange = Date.now();
    }

    const hasLineEnd = /[\r\n]/.test(text);
    const idleEnough = buf.length > 0 && Date.now() - lastChange > 180;
    if (hasLineEnd || idleEnough) {
      term.write(text);
      if (!/[\r\n]$/.test(text)) {
        term.writeln("");
      }
      transport.flushInput();
      return { ok: true, rawText: text };
    }

    await new Promise((r) => setTimeout(r, 40));
  }

  const finalBuf = transport.peek();
  const finalText = dec.decode(finalBuf);
  if (finalText.length > 0) {
    term.write(finalText);
    term.writeln("");
    transport.flushInput();
    return { ok: true, rawText: finalText };
  }
  transport.flushInput();
  return { ok: false, rawText: "" };
}

/** New Ray5: query $20 for limit-switch presence before OTA match. */
async function queryRay5LimitSwitch(
  machineKey: string,
  log: (line: string) => void,
): Promise<boolean | undefined> {
  if (!isLongerLaserRay5(machineKey)) return undefined;
  log(`[Match] querying ${LIMIT_SWITCH_QUERY_CMD} …`);
  const r = await sendConsoleCommandAndShowResponse(LIMIT_SWITCH_QUERY_CMD);
  if (r.rawText) log(`[Match] $20 raw: ${r.rawText.replace(/\r?\n/g, " ").trim()}`);
  const hasLimit = parseLimitSwitchFromD20(r.rawText);
  if (hasLimit === null) {
    log("[Match] $20 limit query unreadable — defaulting to with limit");
    return true;
  }
  log(`[Match] limit switch: ${hasLimit ? "yes ($20=1)" : "no ($20=0)"}`);
  return hasLimit;
}

/** 向 fileTable 添加一个空行（与原 addFileButton.onclick 逻辑一致） */
function addFileRow() {
  const rowCount = table.rows.length;
  const row = table.insertRow(rowCount);

  const cell1 = row.insertCell(0);
  const element1 = document.createElement("input");
  element1.type = "text";
  element1.id = "offset" + rowCount;
  element1.value = "0x1000";
  cell1.appendChild(element1);

  const cell2 = row.insertCell(1);
  const element2 = document.createElement("input");
  element2.type = "file";
  element2.id = "selectFile" + rowCount;
  element2.name = "selected_File" + rowCount;
  element2.addEventListener("change", handleFileSelect, false);
  cell2.appendChild(element2);

  const cell3 = row.insertCell(2);
  cell3.classList.add("progress-cell");
  cell3.style.display = "none";
  cell3.innerHTML = `<progress value="0" max="100"></progress>`;

  const cell4 = row.insertCell(3);
  cell4.classList.add("action-cell");
  if (rowCount > 1) {
    const element4 = document.createElement("input");
    element4.type = "button";
    element4.name = "button" + rowCount;
    element4.setAttribute("class", "btn");
    element4.setAttribute("value", "Remove");
    element4.onclick = function () {
      removeRow(row);
    };
    cell4.appendChild(element4);
  }
}

function ensureFirstFlashDataRow() {
  if (table.rows.length < 2) {
    addFileRow();
  }
}

function getFirstFileInputWithData(): FileInputWithData {
  const row = table.rows[1];
  return row.cells[1].childNodes[0] as FileInputWithData;
}

/** 从 OTA 的 resourceUrl 取最后一段作为展示用文件名（含括号等特殊字符） */
function deriveFirmwareFilenameFromResourceUrl(resourceUrl: string): string {
  const s = (resourceUrl || "").trim();
  if (!s) return "firmware.bin";
  try {
    const u = new URL(s);
    const seg = u.pathname.split("/").filter(Boolean).pop();
    if (!seg) return "firmware.bin";
    return decodeURIComponent(seg.replace(/\+/g, " "));
  } catch {
    const noQuery = s.split("?")[0];
    const seg = noQuery.split("/").filter(Boolean).pop();
    return seg ? decodeURIComponent(seg.replace(/\+/g, " ")) : "firmware.bin";
  }
}

/**
 * 将 OTA 下载结果挂到「Add File」生成行的 file input：与手动选文件一样显示文件名，
 * 并设置 `.data` 供 validateProgramInputs / Program 使用。
 */
function assignOtaDownloadToFileInput(fileInp: FileInputWithData, bin: Uint8Array, resourceUrl: string) {
  const name = deriveFirmwareFilenameFromResourceUrl(resourceUrl);
  fileInp.data = bin;
  try {
    const file = new File([bin], name, { type: "application/octet-stream" });
    const dt = new DataTransfer();
    dt.items.add(file);
    fileInp.files = dt.files;
  } catch {
    /* 少数环境无法为 type=file 注入 FileList，仍以 .data 烧录 */
  }
}

function formatBytes(n: number): string {
  const x = Math.max(0, n);
  if (x < 1024) return `${x} B`;
  if (x < 1024 * 1024) return `${(x / 1024).toFixed(1)} KB`;
  return `${(x / (1024 * 1024)).toFixed(2)} MB`;
}

let connectFlowUiDisabledSnapshot: boolean[] | null = null;

function getConnectFlowLockableElements(): (HTMLButtonElement | HTMLSelectElement | HTMLInputElement)[] {
  const fileInputs = Array.from(table.querySelectorAll<HTMLInputElement>("input[type=file]"));
  return [
    connectButton,
    traceButton,
    disconnectButton,
    eraseButton,
    addFileButton,
    programButton as HTMLButtonElement,
    baudrates,
    consoleBaudrates,
    reconnectDelay,
    maxRetriesInput,
    flashMode,
    flashFreq,
    flashSize,
    consoleStartButton,
    consoleStopButton,
    resetButton,
    ...fileInputs,
  ].filter(Boolean) as (HTMLButtonElement | HTMLSelectElement | HTMLInputElement)[];
}

/**
 * ROM 变量 UARTDEV_BUF_NO（与各 chip.postConnect 一致）：USB 虚拟串口 / USB-OTG 时需
 * {@link ESPLoader.after} 的 `usingUsbOtg`，HardReset 才会用 USB 侧时序，否则设备易停在 stub。
 * laserburn 的 `after: "hard_reset"` 与此对应；本库 writeFlash 不自动 after，需在烧录后显式调用。
 */
async function resolveUsbOtgForAfterHardReset(esploader: ESPLoader): Promise<boolean> {
  const chip = esploader.chip as {
    UARTDEV_BUF_NO?: number;
    UARTDEV_BUF_NO_USB?: number;
    UARTDEV_BUF_NO_USB_OTG?: number;
  };
  if (chip?.UARTDEV_BUF_NO == null) return false;
  try {
    const bufNo = (await esploader.readReg(chip.UARTDEV_BUF_NO)) & 0xff;
    if (chip.UARTDEV_BUF_NO_USB !== undefined && bufNo === chip.UARTDEV_BUF_NO_USB) {
      return true;
    }
    if (chip.UARTDEV_BUF_NO_USB_OTG !== undefined && bufNo === chip.UARTDEV_BUF_NO_USB_OTG) {
      return true;
    }
  } catch {
    return false;
  }
  return false;
}

/** OTA 固件下载期间禁止操作主界面控件（含表格内文件选择） */
function setConnectFlowInteractiveLocked(lock: boolean) {
  const els = getConnectFlowLockableElements();
  if (lock) {
    connectFlowUiDisabledSnapshot = els.map((el) => el.disabled);
    for (const el of els) el.disabled = true;
  } else if (connectFlowUiDisabledSnapshot) {
    const snap = connectFlowUiDisabledSnapshot;
    connectFlowUiDisabledSnapshot = null;
    els.forEach((el, i) => {
      el.disabled = snap[i];
    });
  }
}

/** Restore UI when user cancels before stub (e.g. unsupported device). */
async function abortConnectBeforeMain() {
  try {
    if (transport) await transport.disconnect();
  } catch (_) {
    /* ignore */
  }
  device = null;
  deviceInfo = null;
  transport = null as unknown as Transport;
  esploader = null as unknown as ESPLoader;
  chip = null;
  connectButton.style.display = "initial";
  disconnectButton.style.display = "none";
  traceButton.style.display = "none";
  eraseButton.style.display = "none";
  filesDiv.style.display = "none";
  flashMode.style.display = "none";
  flashFreq.style.display = "none";
  flashSize.style.display = "none";
  lblFlashMode.style.display = "none";
  lblFlashFreq.style.display = "none";
  lblFlashSize.style.display = "none";
}

// ============================================================
// Simple Mode state machine
// ============================================================

type SimpleStep = "idle" | "connecting" | "matched" | "downloading" | "confirm" | "flashing" | "done" | "error";

const STEP_IDS: Array<{ id: string; step: SimpleStep }> = [
  { id: "step-connecting", step: "connecting" },
  { id: "step-matched", step: "matched" },
  { id: "step-downloading", step: "downloading" },
  { id: "step-flashing", step: "flashing" },
  { id: "step-done", step: "done" },
];

/** Show/hide sub-panels and update step indicator state.
 * When `step` is `"error"`, pass `errorAtStep` so the indicator marks the phase that failed
 * (e.g. `"connecting"` if the user cancelled the serial picker — not step 4). */
function setSimpleStep(step: SimpleStep, errorAtStep?: SimpleStep) {
  simpleIdlePanel.style.display = step === "idle" ? "flex" : "none";
  simpleProgressPanel.style.display =
    step === "connecting" || step === "matched" || step === "downloading" || step === "flashing"
      ? "flex"
      : "none";
  simpleConfirmPanel.style.display = step === "confirm" ? "flex" : "none";
  simpleErrorPanel.style.display = step === "error" ? "flex" : "none";
  simpleDonePanel.style.display = step === "done" ? "flex" : "none";
  simpleStepsEl.style.display = step !== "idle" ? "flex" : "none";

  if (step === "idle") {
    STEP_IDS.forEach(({ id }) => {
      document.getElementById(id)?.classList.remove("active", "done", "error");
    });
    document.querySelectorAll<HTMLElement>(".step-line").forEach((line) => {
      line.classList.remove("done");
    });
    return;
  }

  const stepOrder: SimpleStep[] = ["connecting", "matched", "downloading", "flashing", "done"];
  let activeIdx: number;
  if (step === "error") {
    const ep =
      errorAtStep && stepOrder.includes(errorAtStep) ? errorAtStep : "connecting";
    activeIdx = stepOrder.indexOf(ep);
    if (activeIdx < 0) activeIdx = 0;
  } else {
    const logical: SimpleStep = step === "confirm" ? "downloading" : step;
    activeIdx = stepOrder.indexOf(logical);
    if (activeIdx < 0) activeIdx = 0;
  }

  STEP_IDS.forEach(({ id }, idx) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.remove("active", "done", "error");
    if (idx < activeIdx) {
      el.classList.add("done");
    } else if (idx === activeIdx) {
      if (step === "error") el.classList.add("error");
      else el.classList.add("active");
    }
  });

  document.querySelectorAll<HTMLElement>(".step-line").forEach((line, idx) => {
    line.classList.toggle("done", idx < activeIdx);
  });
}

/** Update progress bar and percentage label */
function setSimpleProgress(pct: number, label: string) {
  const clamped = Math.max(0, Math.min(100, Math.round(pct)));
  simpleProgressBar.value = clamped;
  simpleProgressPct.textContent = `${clamped}%`;
  simpleStatusText.textContent = label;
  simpleProgressWrap.style.display = "flex";
}

/** Switch to professional mode (called when OTA match fails) */
function switchToProfessionalMode() {
  simpleModeEl.style.display = "none";
  document.getElementById("main").style.display = "block";
}

/**
 * Pause at the confirm step and wait for the user to click Yes (true) or No (false).
 * Listeners are cleaned up on each call to avoid duplicates.
 */
function waitForSimpleConfirm(): Promise<boolean> {
  return new Promise((resolve) => {
    const yes = simpleYesBtn;
    const no = simpleNoBtn;
    const onYes = () => {
      cleanup();
      resolve(true);
    };
    const onNo = () => {
      cleanup();
      resolve(false);
    };
    function cleanup() {
      yes.removeEventListener("click", onYes);
      no.removeEventListener("click", onNo);
    }
    yes.addEventListener("click", onYes, { once: true });
    no.addEventListener("click", onNo, { once: true });
  });
}

/**
 * Populate flash size and frequency dropdowns based on chip's supported values
 */
function populateFlashDropdowns() {
  if (!esploader || !esploader.chip) {
    return;
  }

  // Populate Flash Frequency dropdown
  flashFreq.innerHTML = '<option value="keep">keep</option>';
  const flashFreqKeys = Object.keys(esploader.chip.FLASH_FREQUENCY).sort((a, b) => {
    const freqOrder = ["80m", "60m", "48m", "40m", "30m", "26m", "24m", "20m", "16m", "15m", "12m"];
    const indexA = freqOrder.indexOf(a);
    const indexB = freqOrder.indexOf(b);
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.localeCompare(b);
  });
  flashFreqKeys.forEach((freq) => {
    const option = document.createElement("option");
    option.value = freq;
    option.textContent = freq;
    flashFreq.appendChild(option);
  });
  flashFreq.options[0].selected = true;

  // Populate Flash Size dropdown
  flashSize.innerHTML = '<option value="detect">detect</option><option value="keep">keep</option>';
  const flashSizeKeys = Object.keys(esploader.chip.FLASH_SIZES).sort((a, b) => {
    const sizeOrder = [
      "256KB",
      "512KB",
      "1MB",
      "2MB",
      "2MB-c1",
      "4MB",
      "4MB-c1",
      "8MB",
      "16MB",
      "32MB",
      "64MB",
      "128MB",
    ];
    const indexA = sizeOrder.indexOf(a);
    const indexB = sizeOrder.indexOf(b);
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.localeCompare(b);
  });
  flashSizeKeys.forEach((size) => {
    const option = document.createElement("option");
    option.value = size;
    option.textContent = size;
    flashSize.appendChild(option);
  });
  flashSize.options[1].selected = true;
}

/** 专业模式 Connect 成功后展示 Program 区域（文件表、Flash 选项等） */
function showProfessionalProgramUi(chipName: string) {
  lblBaudrate.style.display = "none";
  lblConnTo.innerHTML = "Connected to device: " + chipName;
  lblConnTo.style.display = "block";
  baudrates.style.display = "none";
  connectButton.style.display = "none";
  disconnectButton.style.display = "initial";
  eraseButton.style.display = "initial";
  filesDiv.style.display = "initial";
  flashMode.style.display = "initial";
  flashFreq.style.display = "initial";
  flashSize.style.display = "initial";
  lblFlashMode.style.display = "initial";
  lblFlashFreq.style.display = "initial";
  lblFlashSize.style.display = "initial";
  consoleDiv.style.display = "none";
}

/**
 * 简易模式 OTA 匹配失败后：保留串口连接，进入专业模式手动选文件烧录。
 */
async function handoffToProfessionalManualMode(
  activeDevice: typeof device,
  activeTransport: Transport,
  activeEsploader: ESPLoader,
): Promise<boolean> {
  device = activeDevice;
  transport = activeTransport;
  esploader = activeEsploader;
  deviceInfo = activeDevice?.getInfo?.() ?? null;
  traceButton.style.display = "initial";
  try {
    term.writeln("Closing port and entering flash mode…");
    await transport.disconnect();
    await new Promise((r) => setTimeout(r, 150));
    chip = await esploader.main();
    populateFlashDropdowns();
    showProfessionalProgramUi(chip);
    ensureFirstFlashDataRow();
    switchToProfessionalMode();
    term.writeln("[Simple] Switched to manual flash mode — select a firmware file below.");
    return true;
  } catch (e) {
    term.writeln(`Error entering flash mode: ${e instanceof Error ? e.message : String(e)}`);
    await abortConnectBeforeMain();
    switchToProfessionalMode();
    return false;
  }
}

// ============================================================
// Simple Mode connect flow
// ============================================================

simpleConnectBtn.onclick = async () => {
  simpleConnectBtn.disabled = true;
  simpleRay5Warning.style.display = "none";
  simpleProgressWrap.style.display = "none";
  simpleProgressBar.value = 0;
  simpleProgressPct.textContent = "0%";

  let localDevice = null;
  let localTransport: Transport = null as unknown as Transport;
  let localEsploader: ESPLoader = null as unknown as ESPLoader;

  const doDisconnect = async () => {
    try {
      if (localTransport) await localTransport.disconnect();
    } catch (_) {
      /* ignore */
    }
    localDevice = null;
    localTransport = null as unknown as Transport;
    localEsploader = null as unknown as ESPLoader;
  };

  /** Phase used when showing an error so the step indicator points at the right step */
  let recoverPhase: SimpleStep = "connecting";
  /** Global `transport` before simple flow swaps it — restored on error */
  let transportBeforeSimpleFlow: Transport | undefined;

  try {
    // ── Step 1: Connect serial port ───────────────────────────
    setSimpleStep("connecting");
    simpleStatusText.textContent = "Connecting…";

    localDevice = await serialLib.requestPort(COMPANY_SERIAL_REQUEST_OPTIONS);
    localTransport = new Transport(localDevice, true);
    const loaderOpts = {
      transport: localTransport,
      baudrate: 921600,
      terminal: espLoaderTerminal,
      debugLogging: false,
    } as LoaderOptions;
    localEsploader = new ESPLoader(loaderOpts);

    // 先用 115200 查 $i
    const appBaud: 115200 | 921600 = 115200;
    await localTransport.connect(appBaud);
    localTransport.readLoop();
    localTransport.flushInput();

    // Temporarily use global `transport` for sendConsoleCommandAndShowResponse
    transportBeforeSimpleFlow = transport;
    transport = localTransport;

    let rawIi = "";
    try {
      let r = await sendConsoleCommandAndShowResponse(FIRMWARE_INFO_CMD);
      if (r.ok && iiResponseLooksValid(r.rawText)) rawIi = r.rawText;
      if (!r.ok || !iiResponseLooksValid(rawIi)) {
        const altBaud = COMPANY_APP_BAUD_ALT[appBaud];
        simpleStatusText.textContent = `Trying ${altBaud} baud…`;
        await localTransport.disconnect();
        await new Promise((r) => setTimeout(r, 120));
        await localTransport.connect(altBaud);
        localTransport.readLoop();
        localTransport.flushInput();
        r = await sendConsoleCommandAndShowResponse(FIRMWARE_INFO_CMD);
        if (r.ok && iiResponseLooksValid(r.rawText)) rawIi = r.rawText;
      }
    } catch (_) {
      /* No $i reply — still in connect phase until we leave for OTA */
    }

    recoverPhase = "matched";
    // ── Step 2: OTA match ─────────────────────────────────────
    setSimpleStep("matched");
    simpleStatusText.textContent = "Detecting device…";

    const parsed = parseIiBracketFields(rawIi);
    const { machineKey, source } = resolveCanonicalMachineKey(parsed, rawIi);
    otaLog(`[Match] machineKey=${machineKey || "(empty)"} (${source})`);
    if (rawIi) {
      otaLog(`[Match] $i raw: ${rawIi.replace(/\r?\n/g, " ").trim()}`);
    } else {
      otaLog("[Match] WARNING: no $i response from device");
    }

    if (isLongerLaserOldB1(machineKey)) {
      window.alert(MSG_ONLINE_OTA_NOT_SUPPORTED);
      transport = transportBeforeSimpleFlow as Transport;
      await doDisconnect();
      setSimpleStep("idle");
      simpleConnectBtn.disabled = false;
      return;
    }
    if (isMksRay5Firmware12x(parsed, machineKey)) {
      window.alert(MSG_ONLINE_OTA_NOT_SUPPORTED);
      transport = transportBeforeSimpleFlow as Transport;
      await doDisconnect();
      setSimpleStep("idle");
      simpleConnectBtn.disabled = false;
      return;
    }

    const otaList = await fetchOtaFirmwareList(otaLog);
    otaLog(`[OTA] using ${otaList.length} entries for match`);
    const ray5HasLimit = await queryRay5LimitSwitch(machineKey, otaLog);
    const matched = matchFirmwareResource(otaList, parsed, machineKey, {
      ...(ray5HasLimit !== undefined ? { ray5HasLimit } : {}),
      log: otaLog,
    });

    transport = transportBeforeSimpleFlow as Transport;

    if (!matched?.resourceUrl) {
      otaLog("[Simple] No firmware match — switching to advanced mode after delay.");
      simpleStatusText.textContent = "Device matching failed. Please use manual flashing.";
      const spin = simpleProgressPanel.querySelector(".simple-spinner") as HTMLElement | null;
      if (spin) spin.style.display = "none";
      await new Promise((r) => setTimeout(r, 2000));
      if (spin) spin.style.display = "";
      transport = transportBeforeSimpleFlow as Transport;
      await handoffToProfessionalManualMode(localDevice, localTransport, localEsploader);
      localDevice = null;
      localTransport = null as unknown as Transport;
      localEsploader = null as unknown as ESPLoader;
      simpleConnectBtn.disabled = false;
      return;
    }

    recoverPhase = "downloading";
    // ── Step 3: Download firmware ─────────────────────────────
    setSimpleStep("downloading");
    simpleStatusText.textContent = `Downloading firmware ${matched.latestVersion || ""}…`;
    simpleProgressWrap.style.display = "flex";

    let lastProgressAt = 0;
    const THROTTLE = 100;
    const bin = await fetchUrlAsUint8Array(matched.resourceUrl, {
      log: otaLog,
      onProgress(loaded, total) {
        const now = Date.now();
        const force = total !== null && total > 0 && loaded >= total;
        if (!force && now - lastProgressAt < THROTTLE) return;
        lastProgressAt = now;
        const pct = total !== null && total > 0 ? (loaded / total) * 100 : 0;
        setSimpleProgress(
          pct,
          `Downloading ${formatBytes(loaded)}${total ? ` / ${formatBytes(total)}` : ""}…`,
        );
      },
    });
    setSimpleProgress(100, "Download complete");

    // ── confirm: ask user to proceed ─────────────────────────
    setSimpleStep("confirm");
    // Current version from $i Software field
    const currentVer = (parsed.Software || "").trim() || "Unknown";
    const latestVer = matched.latestVersion || "Unknown";
    simpleDeviceType.textContent = `Firmware (${formatBytes(bin.byteLength)})`;
    simpleCurrentVersion.textContent = currentVer;
    simpleLatestVersion.textContent = latestVer;
    simpleRay5Warning.style.display = "none";

    const userConfirmed = await waitForSimpleConfirm();
    if (!userConfirmed) {
      await doDisconnect();
      setSimpleStep("idle");
      simpleConnectBtn.disabled = false;
      return;
    }

    recoverPhase = "flashing";
    // ── Step 4: Flash firmware ────────────────────────────────
    setSimpleStep("flashing");
    simpleProgressWrap.style.display = "flex";
    setSimpleProgress(0, "Preparing to flash…");

    // 借用全局引用（populateFlashDropdowns / writeFlash 需要）
    transport = localTransport;
    esploader = localEsploader;
    device = localDevice;

    await localTransport.disconnect();
    await new Promise((r) => setTimeout(r, 150));

    const chipName = await localEsploader.main();
    setSimpleProgress(5, `Connected to ${chipName}, flashing…`);

    ensureFirstFlashDataRow();
    const offEl = table.rows[1].cells[0].childNodes[0] as HTMLInputElement;
    offEl.value = "0x0";
    assignOtaDownloadToFileInput(getFirstFileInputWithData(), bin, matched.resourceUrl);

    const flashOpts: FlashOptions = {
      fileArray: [{ data: bin, address: 0x0 }],
      eraseAll: false,
      compress: true,
      flashMode: "keep" as FlashModeValues,
      flashFreq: "keep" as FlashFreqValues,
      flashSize: "keep" as FlashSizeValues,
      reportProgress: (_fi, written, total) => {
        const pct = 5 + (written / total) * 93;
        setSimpleProgress(pct, `Flashing ${formatBytes(written)} / ${formatBytes(total)}…`);
      },
      calculateMD5Hash: (image: Uint8Array) => {
        const latin1 = Array.from(image, (byte) => String.fromCharCode(byte)).join("");
        return CryptoJS.MD5(CryptoJS.enc.Latin1.parse(latin1)).toString();
      },
    };
    await localEsploader.writeFlash(flashOpts);
    setSimpleProgress(99, "Flash complete, resetting device…");

    // 硬复位
    const usbOtg = await resolveUsbOtgForAfterHardReset(localEsploader);
    await localEsploader.after("hard_reset", usbOtg);
    await localTransport.setDTR(false);
    await localTransport.setRTS(false);
    await new Promise((r) => setTimeout(r, 50));
    await localTransport.setRTS(true);
    await new Promise((r) => setTimeout(r, 100));
    await localTransport.setRTS(false);
    await localTransport.setDTR(false);

    // ── done ─────────────────────────────────────────────────
    setSimpleStep("done");
    await doDisconnect();
    transport = null as unknown as Transport;
    esploader = null as unknown as ESPLoader;
    device = null;
  } catch (e) {
    const raw = e instanceof Error ? e.message : String(e);
    const portCancelled = /No port selected|not selected by the user/i.test(raw);
    simpleErrorText.textContent = portCancelled ? "No serial port was selected." : raw;
    setSimpleStep("error", recoverPhase);
    // eslint-disable-next-line no-console
    console.error(e);
    await doDisconnect();
    if (transportBeforeSimpleFlow !== undefined) {
      transport = transportBeforeSimpleFlow;
    }
    esploader = null as unknown as ESPLoader;
    device = null;
  } finally {
    simpleConnectBtn.disabled = false;
  }
};

simpleRetryBtn.onclick = () => {
  setSimpleStep("idle");
};

simpleRestartBtn.onclick = () => {
  setSimpleStep("idle");
};

// ============================================================
// Professional Mode connect flow
// ============================================================
connectButton.onclick = async () => {
  try {
    if (device === null) {
      device = await serialLib.requestPort(COMPANY_SERIAL_REQUEST_OPTIONS);
      deviceInfo = device.getInfo();
      transport = new Transport(device, true);
    }
    const flashBaud = parseInt(baudrates.value, 10);
    const flashOptions = {
      transport,
      baudrate: Number.isFinite(flashBaud) && flashBaud > 0 ? flashBaud : 921600,
      terminal: espLoaderTerminal,
      debugLogging: debugLogging?.checked ?? false,
    } as LoaderOptions;
    esploader = new ESPLoader(flashOptions);

    traceButton.style.display = "initial";

    const appBaudParsed = parseInt(consoleBaudrates.value, 10);
    const appBaud: 115200 | 921600 =
      appBaudParsed === 115200 || appBaudParsed === 921600 ? appBaudParsed : 115200;

    term.writeln(`Opening port at ${appBaud} baud…`);
    await transport.connect(appBaud);
    transport.readLoop();
    transport.flushInput();

    let rawIi = "";
    try {
      let r = await sendConsoleCommandAndShowResponse(FIRMWARE_INFO_CMD);
      if (r.ok && iiResponseLooksValid(r.rawText)) rawIi = r.rawText;
      if (!r.ok || !iiResponseLooksValid(rawIi)) {
        const altBaud = COMPANY_APP_BAUD_ALT[appBaud];
        term.writeln(`No bytes at ${appBaud} baud — closing port, reopening at ${altBaud} baud, retrying $i…`);
        await transport.disconnect();
        await new Promise((r) => setTimeout(r, 120));
        await transport.connect(altBaud);
        transport.readLoop();
        transport.flushInput();
        r = await sendConsoleCommandAndShowResponse(FIRMWARE_INFO_CMD);
        if (r.ok && iiResponseLooksValid(r.rawText)) rawIi = r.rawText;
        if (!rawIi) {
          term.writeln(
            "(no serial reply at 115200 or 921600 — put device in application mode if needed, or firmware may not support $i)",
          );
        }
      }
    } catch (e) {
      term.writeln(`Firmware query error: ${e instanceof Error ? e.message : String(e)}`);
    }

    const parsed = parseIiBracketFields(rawIi);
    const { machineKey, source } = resolveCanonicalMachineKey(parsed, rawIi);
    otaLog(`[Match] machineKey=${machineKey || "(empty)"} (${source})`);
    if (rawIi) {
      otaLog(`[Match] $i raw: ${rawIi.replace(/\r?\n/g, " ").trim()}`);
    } else {
      otaLog("[Match] WARNING: no $i response from device");
    }

    if (isLongerLaserOldB1(machineKey)) {
      window.alert(MSG_ONLINE_OTA_NOT_SUPPORTED);
      term.writeln("[OTA] Longer Laser Old B1 — online OTA not supported.");
      await abortConnectBeforeMain();
      return;
    }

    const skipOtaForRay5_12 = isMksRay5Firmware12x(parsed, machineKey);
    if (skipOtaForRay5_12) {
      window.alert(MSG_ONLINE_OTA_NOT_SUPPORTED);
      term.writeln(
        "[OTA] Skipped for MKS Ray5 firmware 1.2.x — online OTA not supported; use a manual firmware file if needed.",
      );
    } else {
      const otaList = await fetchOtaFirmwareList(otaLog);
      otaLog(`[OTA] using ${otaList.length} entries for match`);
      const ray5HasLimit = await queryRay5LimitSwitch(machineKey, otaLog);
      const matched = matchFirmwareResource(otaList, parsed, machineKey, {
        ...(ray5HasLimit !== undefined ? { ray5HasLimit } : {}),
        log: otaLog,
      });

      if (matched?.resourceUrl) {
        term.writeln(`[OTA] Matched ${matched.deviceType}, downloading ${matched.latestVersion || ""} …`);
        ensureFirstFlashDataRow();
        setConnectFlowInteractiveLocked(true);
        let lastProgressAt = 0;
        const PROGRESS_THROTTLE_MS = 150;
        try {
          const bin = await fetchUrlAsUint8Array(matched.resourceUrl, {
            log: otaLog,
            onProgress(loaded, total) {
              const now = Date.now();
              const force = total !== null && total > 0 && loaded >= total;
              if (!force && now - lastProgressAt < PROGRESS_THROTTLE_MS) return;
              lastProgressAt = now;
              const line =
                total !== null && total > 0
                  ? `[OTA] ${formatBytes(loaded)} / ${formatBytes(total)} (${Math.min(
                      100,
                      Math.round((loaded / total) * 100),
                    )}%)`
                  : `[OTA] Downloaded ${formatBytes(loaded)} …`;
              term.write(`\x1b[2K\r${line}`);
            },
          });
          term.write("\x1b[2K\r");
          const offEl = table.rows[1].cells[0].childNodes[0] as HTMLInputElement;
          offEl.value = "0x0";
          const fileInp = getFirstFileInputWithData();
          assignOtaDownloadToFileInput(fileInp, bin, matched.resourceUrl);
          term.writeln(`[OTA] Loaded ${formatBytes(bin.byteLength)} (flash address set to 0x0)`);
        } catch (e) {
          term.write("\x1b[2K\r");
          term.writeln(`[OTA] Download failed: ${e instanceof Error ? e.message : String(e)}`);
        } finally {
          setConnectFlowInteractiveLocked(false);
        }
      } else {
        term.writeln(
          "[OTA] No firmware match found for this device — please select a file manually via Add File.",
        );
      }
    }

    term.writeln("Closing port and entering flash mode…");
    await transport.disconnect();
    await new Promise((r) => setTimeout(r, 150));

    chip = await esploader.main();

    // Populate flash dropdowns based on chip's supported values
    populateFlashDropdowns();

    // Temporarily broken
    // await esploader.flashId();
    // eslint-disable-next-line no-console
    console.log("Settings done for :" + chip);
    showProfessionalProgramUi(chip);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    term.writeln(`Error: ${e.message}`);
  }
};

traceButton.onclick = async () => {
  if (transport) {
    transport.returnTrace();
  }
};

resetButton.onclick = async () => {
  if (transport) {
    await transport.setDTR(false);
    await new Promise((resolve) => setTimeout(resolve, 100));
    await transport.setDTR(true);
  }
};

eraseButton.onclick = async () => {
  eraseButton.disabled = true;
  try {
    await esploader.eraseFlash();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    term.writeln(`Error: ${e.message}`);
  } finally {
    eraseButton.disabled = false;
  }
};

if (addFileButton) {
  addFileButton.onclick = () => addFileRow();
}

/**
 * The built in HTMLTableRowElement object.
 * @external HTMLTableRowElement
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLTableRowElement}
 */

/**
 * Remove file row from HTML Table
 * @param {HTMLTableRowElement} row Table row element to remove
 */
function removeRow(row: HTMLTableRowElement) {
  const rowIndex = Array.from(table.rows).indexOf(row);
  table.deleteRow(rowIndex);
}

/**
 * Clean devices variables on chip disconnect. Remove stale references if any.
 */
function cleanUp() {
  device = null;
  deviceInfo = null;
  transport = null;
  chip = null;
}

disconnectButton.onclick = async () => {
  if (transport) await transport.disconnect();

  term.reset();
  lblBaudrate.style.display = "initial";
  baudrates.style.display = "initial";
  consoleBaudrates.style.display = "initial";
  connectButton.style.display = "initial";
  disconnectButton.style.display = "none";
  traceButton.style.display = "none";
  eraseButton.style.display = "none";
  lblConnTo.style.display = "none";
  filesDiv.style.display = "none";
  flashMode.style.display = "none";
  flashFreq.style.display = "none";
  flashSize.style.display = "none";
  lblFlashMode.style.display = "none";
  lblFlashFreq.style.display = "none";
  lblFlashSize.style.display = "none";
  alertDiv.style.display = "none";
  consoleDiv.style.display = "initial";
  cleanUp();
};

let isConsoleClosed = false;
let isReconnecting = false;

const sleep = async (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

consoleStartButton.onclick = async () => {
  if (device === null) {
    device = await serialLib.requestPort(COMPANY_SERIAL_REQUEST_OPTIONS);
    transport = new Transport(device, true);
    deviceInfo = device.getInfo();

    // Set up device lost callback
    transport.setDeviceLostCallback(async () => {
      if (!isConsoleClosed && !isReconnecting) {
        term.writeln("\n[DEVICE LOST] Device disconnected. Trying to reconnect...");
        await sleep(parseInt(reconnectDelay.value));
        isReconnecting = true;

        const maxRetries = parseInt(maxRetriesInput.value);
        let retryCount = 0;

        while (retryCount < maxRetries && !isConsoleClosed) {
          retryCount++;
          term.writeln(`\n[RECONNECT] Attempt ${retryCount}/${maxRetries}...`);

          if (serialLib && serialLib.getPorts) {
            const ports = await serialLib.getPorts();
            if (ports.length > 0) {
              const newDevice = ports.find(
                (port) =>
                  port.getInfo().usbVendorId === deviceInfo.usbVendorId &&
                  port.getInfo().usbProductId === deviceInfo.usbProductId,
              );

              if (newDevice) {
                device = newDevice;
                transport.updateDevice(device);
                term.writeln("[RECONNECT] Found previously authorized device, connecting...");
                await transport.connect(parseInt(consoleBaudrates.value));
                term.writeln("[RECONNECT] Successfully reconnected!");
                consoleStopButton.style.display = "initial";
                resetButton.style.display = "initial";
                isReconnecting = false;

                startConsoleReading();
                return;
              }
            }
          }

          if (retryCount < maxRetries) {
            term.writeln(`[RECONNECT] Device not found, retrying in ${parseInt(reconnectDelay.value)}ms...`);
            await sleep(parseInt(reconnectDelay.value));
          }
        }

        if (retryCount >= maxRetries) {
          term.writeln("\n[RECONNECT] Failed to reconnect after 5 attempts. Please manually reconnect.");
          isReconnecting = false;
        }
      }
    });
  }

  lblConsoleFor.style.display = "block";
  lblConsoleBaudrate.style.display = "none";
  consoleBaudrates.style.display = "none";
  consoleStartButton.style.display = "none";
  consoleStopButton.style.display = "initial";
  resetButton.style.display = "initial";
  programDiv.style.display = "none";

  await transport.connect(parseInt(consoleBaudrates.value));
  isConsoleClosed = false;
  isReconnecting = false;

  startConsoleReading();
};

/**
 * IDF Monitor–style auto-coloring: inject ANSI codes by log level (E/W/I) so colors
 * work without CONFIG_LOG_COLORS on the device. Same regex as esp-idf-monitor.
 */
const IDF_LOG_LEVEL_REGEX = /^(I|W|E) \([\d.: -]+\)/;
const ANSI = {
  RED: "\x1b[1;31m",
  GREEN: "\x1b[0;32m",
  YELLOW: "\x1b[0;33m",
  NORMAL: "\x1b[0m",
};

/**
 * Use IDF Monitor style log level prefixes to inject ANSI color codes for better readability. Lines that don't match the pattern are returned unmodified.
 * @param {string} line Console line to colorize
 * @returns {string} Colorized console line
 */
function colorizeIdfLine(line: string): string {
  const match = IDF_LOG_LEVEL_REGEX.exec(line);
  if (!match) return line;
  const color = match[1] === "E" ? ANSI.RED : match[1] === "W" ? ANSI.YELLOW : ANSI.GREEN;
  return color + line + ANSI.NORMAL;
}

/**
 * Continuously read from the console until it's closed, applying colorization to IDF log lines. If the connection is lost, it will wait for reconnection and resume reading. Errors are caught and displayed in the terminal without breaking the reading loop.
 */
async function startConsoleReading() {
  if (isConsoleClosed || !transport) return;

  const decoder = new TextDecoder("utf-8");
  let lineBuffer = "";
  try {
    await transport.rawRead(
      (value) => {
        lineBuffer += decoder.decode(value);
        let idx: number;
        while ((idx = lineBuffer.indexOf("\n")) !== -1) {
          const lineWithEol = lineBuffer.slice(0, idx + 1);
          lineBuffer = lineBuffer.slice(idx + 1);
          const lineStripped = lineWithEol.replace(/\r?\n$/, "");
          const eol = lineWithEol.slice(lineStripped.length);
          term.write(colorizeIdfLine(lineStripped) + eol);
        }
      },
      () => isConsoleClosed,
    );
    if (lineBuffer.length > 0) {
      term.write(colorizeIdfLine(lineBuffer));
    }
  } catch (error) {
    if (!isConsoleClosed) {
      term.writeln(`\n[CONSOLE ERROR] ${error instanceof Error ? error.message : String(error)}`);
    }
  }

  if (!isConsoleClosed) {
    term.writeln("\n[CONSOLE] Connection lost, waiting for reconnection...");
  }
}

consoleStopButton.onclick = async () => {
  isConsoleClosed = true;
  isReconnecting = false;
  if (transport) {
    await transport.disconnect();
    await transport.waitForUnlock(1500);
  }
  term.reset();
  lblConsoleBaudrate.style.display = "initial";
  consoleBaudrates.style.display = "initial";
  consoleStartButton.style.display = "initial";
  consoleStopButton.style.display = "none";
  resetButton.style.display = "none";
  lblConsoleFor.style.display = "none";
  programDiv.style.display = "initial";
  cleanUp();
};

/**
 * Validate the provided files images and offset to see if they're valid.
 * @returns {string} Program input validation result
 */
function validateProgramInputs() {
  const offsetArr = [];
  const rowCount = table.rows.length;
  let row;
  let offset = 0;
  let fileData = null;

  // check for mandatory fields
  for (let index = 1; index < rowCount; index++) {
    row = table.rows[index];

    //offset fields checks
    const offSetObj = row.cells[0].childNodes[0];
    offset = parseInt(offSetObj.value);

    // Non-numeric or blank offset
    if (Number.isNaN(offset)) return "Offset field in row " + index + " is not a valid address!";
    // Repeated offset used
    else if (offsetArr.includes(offset)) return "Offset field in row " + index + " is already in use!";
    else offsetArr.push(offset);

    const fileObj = row.cells[1].childNodes[0];
    fileData = fileObj.data;
    if (fileData == null) return "No file selected for row " + index + "!";
  }
  return "success";
}

programButton.onclick = async () => {
  const alertMsg = document.getElementById("alertmsg");
  const err = validateProgramInputs();

  if (err != "success") {
    alertMsg.innerHTML = "<strong>" + err + "</strong>";
    alertDiv.style.display = "block";
    return;
  }

  // Hide error message
  alertDiv.style.display = "none";

  const fileArray = [];
  const progressBars = [];

  for (let index = 1; index < table.rows.length; index++) {
    const row = table.rows[index];

    const offSetObj = row.cells[0].childNodes[0] as HTMLInputElement;
    const offset = parseInt(offSetObj.value);

    const fileObj = row.cells[1].childNodes[0] as ChildNode & { data: Uint8Array };
    const progressBar = row.cells[2].childNodes[0];

    progressBar.textContent = "0";
    progressBars.push(progressBar);

    row.cells[2].style.display = "initial";
    row.cells[3].style.display = "none";

    fileArray.push({ data: fileObj.data, address: offset });
  }

  try {
    const flashOptions: FlashOptions = {
      fileArray: fileArray,
      eraseAll: false,
      compress: true,
      flashMode: flashMode.value as FlashModeValues,
      flashFreq: flashFreq.value as FlashFreqValues,
      flashSize: flashSize.value as FlashSizeValues,
      reportProgress: (fileIndex, written, total) => {
        progressBars[fileIndex].value = (written / total) * 100;
      },
      calculateMD5Hash: (image: Uint8Array) => {
        const latin1String = Array.from(image, (byte) => String.fromCharCode(byte)).join("");
        return CryptoJS.MD5(CryptoJS.enc.Latin1.parse(latin1String)).toString();
      },
    };
    await esploader.writeFlash(flashOptions);
    const usbOtg = await resolveUsbOtgForAfterHardReset(esploader);
    await esploader.after("hard_reset", usbOtg);

    // esploader.after HardReset only calls setRTS(false) without a proper EN pulse.
    // Issue a full reset sequence:
    //   DTR=false → IO0 high (normal boot, not download mode)
    //   RTS=true  → EN low (chip in reset)
    //   delay
    //   RTS=false → EN high (chip boots user firmware)
    //   DTR=false → keep IO0 high
    if (transport) {
      await transport.setDTR(false);
      await transport.setRTS(false);
      await new Promise((r) => setTimeout(r, 50));
      await transport.setRTS(true);
      await new Promise((r) => setTimeout(r, 100));
      await transport.setRTS(false);
      await transport.setDTR(false);
      term.writeln("Hard reset via DTR/RTS done.");
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    term.writeln(`Error: ${e.message}`);
  } finally {
    // Hide progress bars and show erase buttons
    for (let index = 1; index < table.rows.length; index++) {
      table.rows[index].cells[2].style.display = "none";
      table.rows[index].cells[3].style.display = "initial";
    }
  }
};

